import { executeGetRequest, executePutRequest, FetchConfig } from '@api/client';
import { createFetchCurrentUserPath, createUpdateCurrentUserPath } from '@routing/apiUrls';
import { FetchCurrentUserResponse } from '@models/user/FetchCurrentUser';
import { UpdateCurrentUserMutation, UpdateCurrentUserResponse } from '@models/user/UpdateCurrentUser';

export const fetchCurrentUser = async (config?: FetchConfig) => {
    const result = await executeGetRequest<FetchCurrentUserResponse>(createFetchCurrentUserPath(), config);
    return result.data;
};

export const updateCurrentUser = async (data: UpdateCurrentUserMutation, config?: FetchConfig) => {
    const result = await executePutRequest<UpdateCurrentUserResponse>(createUpdateCurrentUserPath(), data, config);
    return result.data;
};
